import styled from 'styled-components';
import resetCSS from '../../styles/reset';

const BlockieStyled = styled.div`
    ${resetCSS}
    border-radius: 50%;
    display: inline-flex;
    overflow: hidden;
`;

export const BlockieStyles = {
    BlockieStyled,
};
